import styled from 'styled-components';

export const StyledSite = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: space-around;
    align-items: center;
    height: 100vh;
`;
